import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import BloodPressureForm from "./components/BloodPressureForm";
import BloodPressureHistory from "./components/BloodPressureHistory";
import AdminDashboard from "./pages/AdminDashboard";
import BloodSugarForm from "./components/BloodSugarForm";
import BloodSugarHistory from "./components/BloodSugarHistory";
import WeightForm from "./components/WeightForm";
import WeightHistory from "./components/WeightHistory";
import ProfileForm from "./components/ProfileForm";
import WaistPage from "./pages/WaistPage";

function App() {
  const [initialRedirect, setInitialRedirect] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));

    if (!token || !user) {
      setInitialRedirect("/login");
    } else if (user.isAdmin) {
      setInitialRedirect("/admin");
    } else {
      setInitialRedirect("/dashboard");
    }
  }, []);

  if (initialRedirect === null) return null; // 等待 useEffect 判斷完成

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={initialRedirect} replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/blood-pressure/new" element={<BloodPressureForm />} />
        <Route path="/blood-pressure/history" element={<BloodPressureHistory />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/blood-sugar/new" element={<BloodSugarForm />} />
        <Route path="/blood-sugar/history" element={<BloodSugarHistory />} />
        <Route path="/weight/new" element={<WeightForm />} />
        <Route path="/weight/history" element={<WeightHistory />} />
        <Route path="/profile" element={<ProfileForm />} />
        <Route path="/waist/new" element={<WaistPage />} />
        <Route path="/waist/history" element={<WaistPage history />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
